import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { DeletePasscodeList } from '@/connection/audiences/passcode-lists';
import { PasscodeList } from '@/types/registration.types';

export const deletePasscodeList = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ channel, list }: { channel: number; list: PasscodeList }) => {
      return await DeletePasscodeList(channel, list);
    },
    {
      fulfilled: (state, action) => {
        state.passcodeLists = state.passcodeLists.filter((list: PasscodeList) => {
          return list.passcode_list !== action?.payload?.listRemoved?.passcode_list;
        });
      },
      rejected: (state, action) => {
        state.loadingPasscodeLists = false;
        console.error(action.error);
      },
    }
  );
